import Cookie from '../../../ports-frontend/Cookie';
import { GAMING_SEGMENTS_COOKIE_NAME } from '../constants';

export const fetchSegmentsCookie = async () => {
  try {
    const cookie = await Cookie.get(GAMING_SEGMENTS_COOKIE_NAME);
    return JSON.parse(cookie);
  } catch (e) {
    return null;
  }
};
